import $  from 'jquery';

// Removes orphans words from content-blocks


function orphansKiller() {
    $('.content-block h1, .content-block h2, .content-block h3, .content-block h4, .content-block h5, .content-block h6, .content-block p').each(function(){
        if(!$(this).hasClass('orphans-disable')){
            let string = $(this).html();
            string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
            $(this).html(string);
        }
    });
}

export { orphansKiller };